export default __webpack_public_path__ + "img/sagoo/seq/sagoo3_1500.webp";